import { restClientV2 } from '@/api/client'
import { endpoints } from '@/api/endpoints'

const q = (p: Record<string, unknown>) => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== undefined && v !== null && v !== '').reduce((a, [k, v]) => ({ ...a, [k]: String(v) }), {})
).toString()

export interface EditWalletBalancePayload {
  action: 'credit' | 'debit'
  amount: number
  reason: string
  user_id: number
}

export interface WalletStudentRow {
  id: number
  name?: string | null
  name_ar?: string | null
  email?: string | null
  phone?: string | null
  photo_url?: string | null
  wallet_balance: number
}

export interface WalletStudentsList {
  total: number
  count_per_page: number
  data: WalletStudentRow[]
}

export interface WalletHistoryEntry {
  id: number
  wallet_id: number
  user_id: number
  admin_id: number
  admin_name?: string | null
  admin_email?: string | null
  action: 'credit' | 'debit'
  amount: number
  previous_balance: number
  new_balance: number
  reason?: string | null
  created_at: string
}

export const walletService = {
  // Server-side searchable/paginated wallet listing — replaces looping over every
  // student page client-side. wallet_filter scopes to students with a balance
  // (e.g. 'positive'); the response body itself carries total/count_per_page (no
  // extra `.data` wrapper, unlike the other v2 endpoints).
  listStudents: (p: { wallet_filter?: string; search?: string; page?: number; limit?: number } = {}): Promise<WalletStudentsList> => {
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 20 }
    if (p.wallet_filter) params.wallet_filter = p.wallet_filter
    if (p.search) params.search = p.search
    return restClientV2.get(`${endpoints.wallet.students}?${q(params)}`).then(r => r.data)
  },
  editBalance: (data: EditWalletBalancePayload) =>
    restClientV2.post(endpoints.wallet.editBalance, data).then(r => r.data?.data),
  editHistory: (p: { user_id: number; page?: number; limit?: number }): Promise<WalletHistoryEntry[]> => {
    const params: Record<string, unknown> = { user_id: p.user_id }
    if (p.page) params.page = p.page
    if (p.limit) params.limit = p.limit
    return restClientV2.get(`${endpoints.wallet.editHistory}?${q(params)}`).then(r => r.data?.data ?? [])
  },
}
